import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrandDirective } from "@shared/directives/brand.directive";
import { TypeDirective } from "@shared/directives/type.directive";
import { ListSearchComponent } from "./components/listSearch/listSearch.component";
import { DescriptionComponent } from "./components/description/description.component";
import { SearchService } from "./services/search.service";
import { CountriesService } from "./services/countries.service";
import { ImagesService } from "./services/images.service";
import { DiffDaysContributed } from "./pipe/diffDaysContributed.pipe";
import { DragAndDropFileDirective } from "./directives/dragAndDropFile.directive";
import { CountUpDirective } from "./directives/count-up.directive";
import { ToolTipDirective } from "./directives/toolTip.directive";
import { NavigationService } from "./services/navigation.service";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    declarations: [
        DescriptionComponent,
        BrandDirective,
        TypeDirective,
        ListSearchComponent,
        DragAndDropFileDirective,
        DiffDaysContributed,
        CountUpDirective,
        ToolTipDirective,
    ],
    exports: [
        CommonModule,
        DescriptionComponent,
        BrandDirective,
        TypeDirective,
        ListSearchComponent,
        FormsModule,
        ReactiveFormsModule,
        DiffDaysContributed,
        DragAndDropFileDirective,
        ReactiveFormsModule,
        CountUpDirective,
        DiffDaysContributed,
        ToolTipDirective,
    ],

    providers: [SearchService, CountriesService, NavigationService, ImagesService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
